/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';

/**
 * Request to create a third person
 * @export
 * @interface CreateThirdPersonRequest
 */
export interface CreateThirdPersonRequest {
    /**
     * Firstname of third person
     * @type {string}
     * @memberof CreateThirdPersonRequest
     */
    firstname?: string;
    /**
     * Lastname of third person
     * @type {string}
     * @memberof CreateThirdPersonRequest
     */
    lastname?: string;
    /**
     * 
     * @type {Address}
     * @memberof CreateThirdPersonRequest
     */
    address?: Address;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof CreateThirdPersonRequest
     */
    phone?: PhoneNumber;
}

/**
 * Check if a given object implements the CreateThirdPersonRequest interface.
 */
export function instanceOfCreateThirdPersonRequest(value: object): value is CreateThirdPersonRequest {
    return true;
}

export function CreateThirdPersonRequestFromJSON(json: any): CreateThirdPersonRequest {
    return CreateThirdPersonRequestFromJSONTyped(json, false);
}

export function CreateThirdPersonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateThirdPersonRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'address': json['address'] == null ? undefined : AddressFromJSON(json['address']),
        'phone': json['phone'] == null ? undefined : PhoneNumberFromJSON(json['phone']),
    };
}

export function CreateThirdPersonRequestToJSON(json: any): CreateThirdPersonRequest {
    return CreateThirdPersonRequestToJSONTyped(json, false);
}

export function CreateThirdPersonRequestToJSONTyped(value?: CreateThirdPersonRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'address': AddressToJSON(value['address']),
        'phone': PhoneNumberToJSON(value['phone']),
    };
}

